import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import swal from "sweetalert";
import Select from "react-select";
import { selectCustomStyles } from "../../../../assets/global/selectCustomStyles";
import { formatPeriod } from "../../../../helper/format_period";

function AddRetainedNetIncomeModal({
  show,
  onClose,
  onSubmit,
  form,
  onFieldChange,
  validated,
  cutoffOptions,
  isLoading,
  isSaving,
  title = "Add Retained Net Income",
  submitLabel = "Add",
}) {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      onHide={onClose}
      size="lg"
    >
      <Form noValidate onSubmit={onSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col-sm">
              <Form.Label className="fw-bold">
                Cutoff <span className="text-danger">*</span>
              </Form.Label>
              <div
                onMouseDown={(e) => {
                  if (!isLoading && cutoffOptions.length === 0) {
                    e.preventDefault();
                    swal({
                      icon: "warning",
                      title: "No Posted Cutoff Found",
                      text: "No available posted cutoffs. Please post a cutoff first.",
                    });
                  }
                }}
              >
                <Select
                  isMulti
                  options={cutoffOptions}
                  value={form.selectedCutoffs}
                  onChange={(options) =>
                    onFieldChange("selectedCutoffs", options || [])
                  }
                  placeholder="Select Cutoff"
                  styles={selectCustomStyles(
                    form.selectedCutoffs.length > 0,
                    validated,
                  )}
                  isLoading={isLoading}
                  isSearchable
                  isClearable
                  closeMenuOnSelect={false}
                  formatOptionLabel={(option, { context }) =>
                    context === "menu" ? (
                      <div className="d-flex flex-column">
                        <span>{option.label}</span>
                        <small className="text-muted">
                          {formatPeriod(option.from, option.to)}
                        </small>
                      </div>
                    ) : (
                      option.label
                    )
                  }
                />
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-6 mb-3 mb-sm-0">
              <Form.Label className="fw-bold">Transaction Number</Form.Label>
              <Form.Control
                type="text"
                value={form.transactionNumber}
                readOnly
                disabled
              />
            </div>
            <div className="col-sm-6">
              <Form.Label className="fw-bold">
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={form.name}
                onChange={(e) => onFieldChange("name", e.target.value)}
                placeholder="Enter name"
                isInvalid={validated && !form.name.trim()}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm">
              <Form.Label className="fw-bold">Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={form.remarks}
                onChange={(e) => onFieldChange("remarks", e.target.value)}
                placeholder="Enter remarks"
                style={{ resize: "none" }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            type="button"
            onClick={onClose}
            disabled={isSaving}
          >
            Close
          </Button>
          <Button variant="primary" type="submit" disabled={isSaving}>
            {isSaving ? "Saving..." : submitLabel}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AddRetainedNetIncomeModal;
